$(function() {
  'use strict';


  /**
   * ダミー投稿フォームにフォーカスを合わすとコメントフォームが現れる
   **/
  $('#comment-dummy').on('focus', function() {
      var user = moko.getUser();

      //フォームにユーザー情報を設定
      if ( user.name  ) {
        $('#form-input-author').val( user.name );
      }
      if ( user.id ) { 
        $('#form-input-user_id').val( user.id );
      }

      $(this).hide();
      var id = $(this).data('target');
      $('#'+id).show();
      $('#'+id+' .form-input-comment #comment').focus();

  });


  /**
   * 新しいダミーフォーム
   **/
  $('#comment-dummy2').on('focus', function() {
      var user = moko.getUser();

      //フォームにユーザー情報を設定
      if ( user.name  ) {
        $('#form-input-author').val( user.name );
      }
      if ( user.id ) { 
        $('#form-input-user_id').val( user.id );
      }

      $(this).parent().hide();
      $('.comment-respond').show();
      $('.form-input-comment #comment').focus();

      //広告を隠す
      moko.hideAd();
  });


  /**
   * 返信リンクをクリックするとコメントフォームが現れる
   **/
  //$('.content').on('click','.reply-link', function() {
  $('.reply-link').on('click touchstart', function() {
//    console.log('click comment reply');
    $('.comment-respond').show();
    $('#comment-dummy2').parent().hide();
    
    //フォームの処理はwordpressのcomment_replyがやってくれる
    var user = moko.getUser();

    //フォームにユーザー情報を設定
    if ( user.name  ) {
      $('#form-input-author').val( user.name );
    }
    if ( user.id ) { 
      $('#form-input-user_id').val( user.id );
    }


    //広告を隠す
    moko.hideAd();
  });



  //id=submitの要素があると .submit()が使えなくなるので消しておく
  //$('#submit').remove();

  /**
   * フォームを投稿する直前の処理
   **/
  $('form.comment-form').submit( function(e) {
  //$('#btn-submit').click( function(e) {
    console.log('click submit button');

    //コメント ユーザー名を書き込む
    var comment_author = $('#form-input-author').val() || null;
    var comment_post_id = $('#comment_post_ID').val();
    var comment_parent = $('#comment_parent').val();
    var comment_url = $('#comment_url').val();
    var comment_content = $('#comment').val();
    var comment_user_id = $('#form-input-user_id').val() || null;
    //console.log( comment_author );

    if ( comment_author ) { 
      var user = moko.getUser();
      user.name = comment_author;
      moko.saveUser(user);
    }

    //firebaseにユーザーを作成して名前を変更する
    /*
    moko.firebase.init().then(function( result ) {
      var fb_user = result.user;
      fb_user.updateProfile( {
          displayName : comment_author
      }).then( function() {
        console.log('ユーザープロフィール 保存成功');
        postComment();
      }).catch( function( err ) { 
        console.error(err);
        postComment();
      });
    });
    function postComment() {
      moko.firebase.postComment( comment_post_id, comment_parent, 
        comment_content, comment_user_id, comment_author, comment_url ).then( function(doc) {
        console.log('コメントデータ 保存成功',doc.id);
        $('#comment_fid').val(doc.id);
        $('#commentform').submit();
      }).catch( function( err ) {
        console.error(err);
        $('#commentform').submit();
      });
    }
    */

    //メッセージを表示
    $('#overlay-message').html('<div class="loading">コメント送信中です...</div>');
    $('#overlay-screen').show();

    //アナリティクスへ送信
    var category = 'comment-post';
    var action = 'comment-post';
    var label = moko.home_url;
    var value = 1;
    var options = {};

    ga('send', 'event',  category, action, label , options );
    ga('all.send', 'event',  category, action, label , options );

    //return false;
    return true;
  });
  /*
  $('form.comment-form').submit( function(e) {
    console.log('form submit 呼ばれた');
    return true;
  });
  */


  //- クリックで通報と削除のメニューを表示 -----------------------------------
  $('.comment-meta__menu').click(function() {

    if ($('.report-delete-set').not(this).hasClass('open')) {//自身以外でclass openがあれば
      $('.report-delete-set').not(this).removeClass('open');//それらは閉じる

    } else {//それ以外の場合
      $('.comment-meta__menu,.report-delete-set',this).toggleClass('open');//自身だけtoggleClass使用

    }	

  });

  // -　スライドで返信を表示 -----------------------------------
  $('.reply-meta').on('click', function() {
    $(this).next().slideToggle();
    $(this).toggleClass('open');//開閉矢印の切り替え
  });


  $('#article_image_file_name').on('change', function(event){
    initializeFiles();

    var files = event.target.files;

    for (var i = 0, f; f = files[i]; i++) {
      var reader = new FileReader;
      reader.readAsDataURL(f);

      reader.onload = (function(theFile) {
        return function (e) {
          var div = document.createElement('div');
          div.className = 'reader_file';
          //div.innerHTML = '<div class="reader_title">' + theFile.name + '</div>';
          div.innerHTML += '<img class="reader_image" src="' + e.target.result + '" />';
          document.getElementById('comment_attachments_list').insertBefore(div, null);
        }
      })(f);
    }
  });

  function initializeFiles() {
    document.getElementById('comment_attachments_list').innerHTML = '';
  }


});
